// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6a127dc6","239":"0b66547e","453":"3b933608","667":"1b2cb392"}[chunkId] + ".chunk.js";
};